import React from 'react'
import GoogleSlidesCaseStudy from '../templates/GoogleSlidesCaseStudy'
import SlideDeck from '../../../assets/decks/publix_ai_master.pdf'

const Work = () => (
  <GoogleSlidesCaseStudy
    pageTitle="Item Management - AI Integration System"
    date="2026"
    role="Lead Designer"
    company="Publix"
    presentationId="2PACX-1vT80oIq-X0yPp0mxss0FWMilPJi_wgjS5plYGDLFmeP_owmbLM9aqslOH3rgBmvVA"
    pdfLink={SlideDeck}
  />
)

export default Work
